import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  [x: PropertyKey]: any;
  className?: string;
  col: number;
  hidden?: boolean;
}>;

export default function Grid({
  children,
  className = "",
  col = 3,
  hidden = false,
  ...rest
}: Props) {
  if (hidden) {
    return null;
  }

  return (
    <div className={`grid grid-cols-${col} ${className}`} {...rest}>
      {children}
    </div>
  );
}
